<template>
<v-progress-circular indeterminate :color="color" :size="size"></v-progress-circular>
</template>

<script>
export default {
  name: 'ButtonLoading',
  props: {
    color: { type: String, default: "white" },
    size: { type: String, default: "25" },
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
</style>
